<template lang="pug">
	div
		Inicio
		Beneficios
		CertificadoComponent
		Precisa_Ajuda
		Posto_Atendimento
</template>

<script>
import Inicio from "@/components/inicio/index.vue";
import Beneficios from "@/components/beneficios/index.vue";
import Escolha_Modelo from "@/components/escolha_modelo/index.vue";
import Precisa_Ajuda from "@/components/precisa_ajuda/index.vue";
import Posto_Atendimento from "@/components/posto_atendimento/index.vue";
import CertificadoComponent from "@/components/certificados/certificados.vue";

export default {
	name: "Home",
	components: {
		Inicio,
		Beneficios,
		Escolha_Modelo,
		Precisa_Ajuda,
		Posto_Atendimento,
		CertificadoComponent
	}
};
</script>
